import { useHistory } from "react-router-dom";
import { ExperienceSummary } from "../../teamExperiences/models/ExperienceSummaryModel"
import { KTSVG } from "../../../helpers/KTSVG";
import { formatDateShortIntl2 } from "../../../helpers/FormatDate";
import { handleImageErrorGray } from "../../../utils/UtilsFiles";
import { defaultProfileImage } from "../../../utils/constants";
import { formatUsdAmount } from "../../../utils/dateValidations";

type Props = {
    experience: ExperienceSummary;
}
export const ExperienceCard = ({ experience }: Props) => {
    const history = useHistory();

    return (
        <div onClick={() => history.push(`/experience/detail/${experience.id}`)} className="experience-preview-invite-card" key={experience.id} >
            <div className="experience-preview-invite-card-img">
                <img className="tap-host-secction-experiences-past-img" src={experience.coverImage ?? ''} onError={handleImageErrorGray} alt={experience.title}/>
            </div>
            <div className="experience-preview-invite-card-info">
            <div className="experience-preview-invite-badges">
                <div className="experience-preview-invite-badge">
                    <div className='line-svg'>
                        <KTSVG path='/media/svg/nobilis/teams_and_partner/mask-success-line-icon.svg' />
                    </div>
                    New
                    <div className='line-svg'>
                        <KTSVG path='/media/svg/nobilis/teams_and_partner/mask-success-line-icon.svg' />
                    </div>
                </div>
                <div className="experience-preview-invite-badge-secondary">
                    Invited by
                </div>
            </div>

            <div className="experience-preview-invite-users">
                <div className="experience-preview-invite-user">
                    <img src={experience.submittedBy.image} onError={(e) => {e.currentTarget.src = defaultProfileImage;}} />
                    <span>{experience.submittedBy.name}</span>
                </div>
                {/* {item.invited.map((u, i) => (
                <div className="experience-preview-invite-user" key={i}>
                    <img src={u.img} />
                    <span>{u.name}</span>
                </div>
                ))} */}
            </div>

            <div className="experience-preview-invite-title">{experience.title}</div>
            <div className="experience-preview-invite-hover w-100">
                <div className="experience-preview-invite-categories mb-4">
                    {experience?.categories && experience.categories.length > 0 ? (
                        experience.categories.slice(0, 3).map((cat: any, idx: number) => (
                            <span key={idx}>{cat.name || cat}</span>
                        ))
                    ) : (
                        <span>lifestyle</span>
                    )}
                </div>
                <div className="experience-preview-invite-description">
                    Make a painting together with Kristina at her studio - be an artist. Invited people who want to learn to paiint or make a painting together for the interior.asdasdad
                </div>
                <div className="experience-preview-details tap-flex-center">
                    <div className="experience-preview-detail">
                        <span className="experience-preview-icon-18">
                            <KTSVG path='/media/svg/nobilis/location-white.svg' />
                        </span>
                        <span className='labels'>{experience?.city || 'Location TBA'}</span>
                    </div>
                    <div className="experience-preview-detail">
                        <span className="experience-preview-icon-18">
                            <KTSVG path='/media/svg/nobilis/calendar-white.svg' />
                        </span>
                        <div className='labels'>
                            {(experience.dates ?? []).map((item,index)=>(
                                <span key={`date-${index}`}>
                                    { formatDateShortIntl2(item.end) == formatDateShortIntl2(item.start) ?
                                        formatDateShortIntl2(item.start) :
                                        `${formatDateShortIntl2(item.start)} / ${formatDateShortIntl2(item.end)}`
                                    }
                                </span>
                            ))}
                        </div>
                        <div className={`labels ${experience.dates?.length > 0 ? 'd-none' : ''}`}>
                            { 'Date TBA' }
                        </div>
                    </div>
                    <div className="experience-preview-detail">
                        <span className="experience-preview-icon-18">
                            <KTSVG path='/media/svg/nobilis/currency-white.svg' />
                        </span>
                        <span className='labels'>{formatUsdAmount(experience.pricePerGuest) || 'Pending'}&nbsp;/&nbsp;{experience?.priceType === 2 || (experience as any)?.price_type === 2 ? 'Group' : 'Guest'}</span>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}